import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const cvmodule = {
	state: {
		cv: ''
	},
	getters: {
		getCV: state => state.cv,
		canEditPersonales : state => state.cv.personales.editablesPorAlumno

			
	},
	actions: {
		requestCV: ({ commit,dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.get('/ws/getCV').then(result => {
					if (result.data.status == 0) {
						commit('setCV', result.data);
						resolve(true);
					} else {
						commit('setError', result.data.status);
						dispatch('sendInfoAboutError',result.data);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		canEditCv: ({ commit, getters }) => {

			let can = false;

			let cv = getters.getCV;

			return new Promise((resolve, reject) => {

				if (!!cv.documentos) {
					can = (cv.documentos.some(d => d.tipo == '1'));
					(!can) ? commit('setError', 38) : '';
				} else {
					commit('setError', 38);
				}

				

				if (can && getters.getusertype == "Empleo") {
					if (cv.profesional.idSalario != 0) {
						can = true;
					} else {
						commit('setError', 37);
						can = false;
					}
				}

				resolve(can);

			});
		},
		editSoftware: ({ dispatch, getters }, software) => {

			let interes = getters.getCV.interes;

			interes.programas = software;

			return new Promise((resolve, reject) => {
				dispatch('updateIntereses', interes).then(r => {
					resolve(true);
				})
			});
		},
		editMovilidad: ({ dispatch, getters }, data) => {

			let interes = getters.getCV.interes;

			for (let i in data) {
				interes[i] = data[i];
			}

			return new Promise((resolve, reject) => {
				dispatch('updateIntereses', interes).then(r => {
					resolve(true);
				})
			});
		},
		editDiscapacidad: ({ dispatch, getters }, status) => {

			let interes = getters.getCV.interes;

			interes.discapacidad = status;

			return new Promise((resolve, reject) => {
				dispatch('updateIntereses', interes).then(r => {
					resolve(true);
				})
			});
		},
		editInteresesProfesionales: ({ dispatch, getters }, data) => {

			data = [{ "nombre": data }]

			let interes = getters.getCV.interes;

			interes.intereses = data;

			return new Promise((resolve, reject) => {
				dispatch('updateIntereses', interes).then(r => {
					resolve(true);
				})
			});
		},
		updateIntereses: ({ commit }, interes) => {

			if(interes.programas == null){
				interes.programas = '';
			}

			return new Promise((resolve, reject) => {
				axios.get(`/ws/editIntereses?jsonS=${JSON.stringify(interes)}`).then(result => {
					if (result.data.status == 0) {
						commit('setIntereses', interes);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editSalario: ({ getters, dispatch }, data) => {
			let profesional = getters.getCV.profesional;
			profesional.idSalario = Number(data);
			return new Promise((resolve, reject) => {
				dispatch('updateProfesionales', profesional).then(r => {
					resolve(true);
				})
			});
		},
		editEnvioProactivoCV: ({ getters, dispatch }, status) => {
			let profesional = getters.getCV.profesional;
			profesional.busqueda_activa = status;
			return new Promise((resolve, reject) => {
				dispatch('updateProfesionales', profesional).then(r => {
					resolve(true);
				})
			});
		},
		editTrabajandoActualmente: ({ getters, dispatch }, status) => {
			let profesional = getters.getCV.profesional;
			profesional.ocupado = status;
			return new Promise((resolve, reject) => {
				dispatch('updateProfesionales', profesional).then(r => {
					resolve(true);
				})
			});
		},
		editPermisoTrabajo: ({ commit }, status) => {
			let data = (status) ? 1 : 0;
			return new Promise((resolve, reject) => {
				axios.post(`/ws/editPermisoTrabajo`, data).then(result => {
					if (result.data.status == 0) {
						commit('setPermisoTrabajo', status);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editPerfilDigital: ({ getters, dispatch }, url) => {
			let profesional = getters.getCV.profesional;
			profesional.linkedin = url;
			return new Promise((resolve, reject) => {
				dispatch('updateProfesionales', profesional).then(r => {
					resolve(true);
				})
			});
		},
		updateProfesionales: ({ commit }, profesionales) => {

			let data = {
				linkedIn: profesionales.linkedin,
				minimaRetribucion: profesionales.idSalario,
				busquedaActiva: (profesionales.busqueda_activa) ? 'si' : 'no',
				trabajando: (profesionales.ocupado) ? 'si' : 'no'
			}

			return new Promise((resolve, reject) => {
				axios.post(`/ws/editProfesionales`, data).then(result => {
					if (result.data.status == 0) {
						commit('setProfesionales', data);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editPersonales: ({ getters, dispatch }, data) => {
			let personales = getters.getCV.personales;

			let provincias = getters.getDominios.provincias;

			for(let i in data){
				personales[i] = data[i]
			}

			//if(!!personales.idProvincia){
			//	personales.provincia = personales.idProvincia;
			//}else{

				for(let i in provincias){
					if(provincias[i] == personales.provincia){
						personales.provincia = i;
						personales.idProvincia = i;
					}
				}

			//}

			return new Promise((resolve, reject) => {
				dispatch('updatePersonales', personales).then(r => {
					resolve(true);
				})
			});
		},
		updatePersonales:({commit}, personales) =>{

			let data  = {
				telefono:'',
				DNI: "",
				email: "",
				movil: "",
				direccion: "",
				ciudad: "",
				cp: "",
				provincia: "",
				idPaisResidencia: "",
				fecha_nacimiento: "",
				comunicacionesEnEmailEstudiante : "",
			};

			for(let i in personales){
				(data[i] != null) ? data[i] = personales[i] : null;
			}

			data.cp = personales.CP
	
			return new Promise((resolve, reject) => {
				axios.post(`/ws/editBasicos?jsonS=${JSON.stringify(data)}`).then(result => {
					if (result.data.status == 0) {
						commit('setPersonales', data);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});

		},
		addIdioma: ({ commit,dispatch }, idioma) => {
			return new Promise((resolve, reject) => {
				axios.get(`/ws/addIdioma?jsonS=${JSON.stringify(idioma)}`).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editIdioma: ({ commit }, idioma) => {
			return new Promise((resolve, reject) => {
				axios.get(`/ws/editIdioma?jsonS=${JSON.stringify(idioma)}`).then(result => {
					if (result.data.status == 0) {
						commit('editIdioma', idioma);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		eraseIdioma: ({ commit }, id) => {
			return new Promise((resolve, reject) => {
				axios.get(`/ws/deleteIdioma?myid=${id}`).then(result => {
					if (result.data.status == 0) {
						commit('eraseIdioma', id);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		addDoc: ({ commit }, doc) => {
			return new Promise((resolve, reject) => {

				(doc.tipo == "10") ? doc.tipo = '' : null;

				let form = new FormData();

				form.append('jsonS', JSON.stringify(doc));

				axios.post(`/ws/addDocumento?`, form).then(result => {
					if (result.data.status == 0) {
						doc.id = result.data.idNuevaAlta;
						doc.enlace = result.data.enlace;
						commit('addDoc', doc);
						resolve(true);
					} else {
						commit('setError', result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		eraseDoc: ({ commit }, id) => {
			return new Promise((resolve, reject) => {
				axios.get(`/ws/deleteDocumento?myid=${id}`).then(result => {
					if (result.data.status == 0) {
						commit('eraseDoc', id);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		addExperiencia: ({ dispatch }, experiencia) => {

			let form = new FormData();


			form.append('jsonS', JSON.stringify(experiencia));

			return new Promise((resolve, reject) => {
				axios.post(`/ws/addExperiencia`, form).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editExperiencia: ({ dispatch, commit }, experiencia) => {

			let form = new FormData();

			form.append('jsonS', JSON.stringify(experiencia));

			return new Promise((resolve, reject) => {
				axios.post(`/ws/editExperiencia`, form).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		eraseExperiencia: ({ commit }, id) => {
			return new Promise((resolve, reject) => {
				axios.get(`/ws/deleteExperiencia?myid=${id}`).then(result => {
					if (result.data.status == 0) {
						commit('eraseExperiencia', id);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		eraseEstudio: ({ commit }, id) => {
			return new Promise((resolve, reject) => {
				axios.get(`/ws/deleteEstudio?myid=${id}`).then(result => {
					if (result.data.status == 0) {
						commit('eraseEstudio', id);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		addEstudio: ({ dispatch }, estudio) => {


			let form = new FormData();

			form.append('jsonS', JSON.stringify(estudio));

			return new Promise((resolve, reject) => {
				axios.post(`/ws/addEstudio`, form).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editEstudio: ({ dispatch }, estudio) => {

			let form = new FormData();

			form.append('jsonS', JSON.stringify(estudio));

			return new Promise((resolve, reject) => {
				axios.post(`/ws/editEstudio`, form).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editResumen: ({ commit }, resumen) => {
			return new Promise((resolve, reject) => {
				axios.get(`/ws/editResumen?jsonS=${resumen}`).then(result => {
					if (result.data.status == 0) {
						commit('setResumen', resumen);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		
	},
	mutations: {
		setCV(state, data) {
			state.cv = data
		},
		setIntereses(state, intereses) {
			state.cv.interes = intereses
		},
		addIdioma(state, idioma) {
			if(!!!state.cv.idiomas){
				state.cv.idiomas = new Array();
			}
			state.cv.idiomas.push(idioma);
		},
		eraseIdioma(state, id) {
			state.cv.idiomas = state.cv.idiomas.filter(i => i.id != id)
		},
		editIdioma(state, idioma) {
			state.cv.idiomas.forEach(i => {
				(i.id == idioma.id) ? i = idioma : null;
			})
		},
		eraseDoc(state, id) {
			state.cv.documentos = state.cv.documentos.filter(i => i.id != id)
		},
		eraseExperiencia(state, id) {
			state.cv.profesional.experiencia = state.cv.profesional.experiencia.filter(i => i.id != id)
		},
		setProfesionales(state, data) {
			state.cv.profesional.linkedin = data.linkedIn;
			state.cv.profesional.idSalario = data.minimaRetribucion;
			state.cv.profesional.busqueda_activa = (data.busquedaActiva == 'si');
			state.cv.profesional.ocupado = (data.trabajando == 'si');
		},
		setPersonales(state, data) {
			for(let i in data){
				if(i != 'fecha_nacimiento'){
					state.cv.personales[i] = data[i] 
				}else{
					let split = data[i].split("/");
      				let date = new Date(split[2], Number(split[1])-1, split[0]);
					state.cv.personales[i] = `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`
				}

			}
		},
		addDoc(state, doc) {
			if(!!!state.cv.documentos){
				state.cv.documentos = new Array();
			}
			state.cv.documentos.push(doc);
		},
		setPermisoTrabajo(state, status) {
			state.cv.tienePermisoTrabajo = status;
		},
		eraseEstudio(state, id) {
			state.cv.academicos = state.cv.academicos.filter(i => i.id != id)
		},
		setResumen(state,resumen){
			state.cv.resumenCV = resumen;
		}
	}
}

export default cvmodule;


// WEBPACK FOOTER //
// ./src/store/CVmodule.js